import React from "react";
import { FiZap, FiCheckCircle, FiFileText } from "react-icons/fi";
import { MdAccountBalance } from "react-icons/md";
import { FaHandshake } from "react-icons/fa";
import "./Features.css";

const features = [
  {
    title: "Fast Funding",
    desc: "Get approved and receive funds as soon as the next business day.",
    icon: <FiZap />,
  },
  {
    title: "Simple Process",
    desc: "Complete our straightforward application in just a few minutes.",
    icon: <FiCheckCircle />,
  },
  {
    title: "Clear Terms",
    desc: "All fees and repayment details are presented upfront with no surprises.",
    icon: <FiFileText />,
  },
  {
    title: "Direct to Your Account",
    desc: "Money is sent directly to your checking account once approved.",
    icon: <MdAccountBalance />,
  },
  {
    title: "Responsible Lending",
    desc: "We offer solutions designed for short-term, urgent financial needs.",
    icon: <FaHandshake />,
  },
];

const Features = () => {
  return (
    <section className="features">
      <div className="features-header">
        <h2>Our Features</h2>
        <p>Everything you need to manage and grow your finances smarter</p>
      </div>

      <div className="features-grid">
        {features.map((f, i) => (
          <div key={i} className="feature-card">
            <div className="feature-icon">{f.icon}</div>
            <h3>{f.title}</h3>
            <p>{f.desc}</p>
          </div>
        ))}
      </div>

      <div className="features-cta">
        <h3>Ready to take control of your money?</h3>
        <p>Join thousands of users who trust us with their financial journey.</p>
        <button className="cta-btn">Get Started</button>
      </div>
    </section>
  );
};

export default Features;
